const PropTypes = require('prop-types');
const React = require('react');
const { Tracker } = require('@reverbdotcom/discovery-ui');
const CartItem = require('./cart_item');
const PriceDisplay = require('components/shared/price_display');
const UrlHelpers = require('components/shared/url_helpers');
const CartStore = require('components/cart/cart_store');
const CartActions = require('components/cart/cart_actions');
const LPListingsActions = require('components/lp_listings/lp_listings_actions');
const LPListingsStore = require('components/lp_listings/lp_listings_store');
const hoverDropdown = require('../hover_dropdown');

const MAXIMUM_VISIBLE_CART_ITEMS = 3;
const TRACK_NAME = 'CartBadge';

class CartBadge extends React.Component {
  constructor(props) {
    super(props);

    this.onCartUpdated = this.onCartUpdated.bind(this);
    this.onLPListingsLoaded = this.onLPListingsLoaded.bind(this);
    this.trackClick = this.trackClick.bind(this);

    this.state = {
      cart: null,
      lpListings: [],
    };
  }

  componentDidMount() {
    CartStore.listen(this.onCartUpdated);
    LPListingsStore.listen(this.onLPListingsLoaded);
    CartActions.loadCart();
  }

  componentDidUpdate(prevProps) {
    if (!this.hasItems) { return; }

    if (this.props.isOpen && !prevProps.isOpen) {
      Tracker.view({
        name: TRACK_NAME,
        context: {
          count: this.countForDataTag,
          visible_items: this.visibleCartItems.length,
        },
      });
    }
  }

  componentWillUnmount() {
    CartStore.unlisten(this.onCartUpdated);
    LPListingsStore.unlisten(this.onLPListingsLoaded);
  }

  onCartUpdated() {
    const { cart } = CartStore.getState();
    this.setState({ cart }, () => {
      if (this.lpListingIds().length) {
        LPListingsActions.loadListings(this.lpListingIds());
      }
    });
  }

  onLPListingsLoaded() {
    const { lpListings } = LPListingsStore.getState();
    this.setState({ lpListings });
  }

  lpListingIds() {
    return this.state.cart.cartItems.reduce((ids, cartItem) => {
      if (cartItem.lp) { ids.push(cartItem.productId); }
      return ids;
    }, []);
  }

  get cartCount() {
    if (!this.state.cart) { return null; }

    return this.state.cart.count;
  }

  get countForDataTag() {
    if (this.cartCount > 0) { return this.cartCount; }
    return null;
  }

  get hasItems() {
    return this.state.cart && this.cartCount > 0;
  }

  get hasBucks() {
    return this.props.reverbBucks && this.props.reverbBucks.amount_cents > 0;
  }

  get bucksIcon() {
    return '<div class="reverb-bucks-icon"></div>';
  }

  merchandisingDataFor(item) {
    return this.state.lpListings.find(listing => listing.id === item.productId);
  }

  get visibleCartItems() {
    if (!this.state.cart) { return []; }

    return this.state.cart.cartItems.slice(0, MAXIMUM_VISIBLE_CART_ITEMS);
  }

  trackClick() {
    Tracker.trackInteraction({
      name: TRACK_NAME,
      clientSide: false,
      context: {
        count: this.countForDataTag,
        visible_items: this.visibleCartItems.length,
      },
    });
  }

  renderCartItems() {
    return this.visibleCartItems.map((item, i) => (
      <li
        key={i}
        data-cart-item-preview
      >
        <CartItem item={item} merchandisingData={this.merchandisingDataFor(item)} trackClick={this.trackClick} />
      </li>
    ));
  }

  renderBucksSummary() {
    if (!this.hasBucks) { return null; }

    const text = I18n.t('js.headerCart.reverbBucksWithIconHtml', { icon: this.bucksIcon });
    return (
      <li>
        <a
          href={UrlHelpers.cartPath}
          className="site-header__menu__bucks-callout site-header__menu__bucks-callout--single"
          onClick={this.trackClick}
        >
          <span
            className="mr-half"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <PriceDisplay
            price={this.props.reverbBucks}
            showCurrency
          />
        </a>
      </li>
    );
  }

  renderDropdown() {
    if (!this.hasItems) { return null; }

    return (
      <div
        className="site-header__menu site-header__menu--cart"
        data-dropdown-active={this.props.isOpen}
      >
        <ul>
          {this.renderBucksSummary()}
          {this.renderCartItems()}
          <li className="site-header__menu__footer">
            <a
              className="btn btn-primary btn-small wide"
              href={UrlHelpers.cartPath}
              onClick={this.trackClick}
            >
              {I18n.t('js.headerCart.viewCart')}
            </a>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div
        onMouseEnter={this.props.handleMouseEnter}
        onMouseLeave={this.props.handleMouseLeave}
      >
        <a
          className="site-header__nav__link site-header__nav__link--cart-icon"
          href={UrlHelpers.cartPath}
          onClick={this.trackClick}
        >
          <div
            className="site-header__nav__link__icon"
            data-notification-count={this.countForDataTag}
          />
          <div className="site-header__nav__link__label">
            {I18n.t('js.headerCart.badgeLabel')}
          </div>
        </a>
        {this.renderDropdown()}
      </div>
    );
  }
}

CartBadge.propTypes = {
  reverbBucks: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
};

module.exports = hoverDropdown(CartBadge, 'CartBadge');



// WEBPACK FOOTER //
// ./javascripts/components/header/cart/cart_badge.jsx